import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChartLine,
  faFileAlt,
  faProjectDiagram,
  faGlobe,
  faSatellite,
  faTools,
  faBell,
  faChartBar,
  faSearch,
  faEye,
  faEnvelope,
  faRobot
} from '@fortawesome/free-solid-svg-icons';

const Sidebar = ({ activeTab, onAIAssistantClick }) => {
  const [aiAssistantClicked, setAiAssistantClicked] = React.useState(false);

  const menuItems = [
    { id: 'overview', label: 'Overview', icon: faChartLine },
    { id: 'ai-assistant', label: 'AI Assistant', icon: faRobot, isButton: true },
    { id: 'alerts', label: 'Alerts', icon: faBell },
    { id: 'metrics', label: 'Live Metrics', icon: faEye },
    { id: 'logs', label: 'Logs', icon: faFileAlt },
    { id: 'pipelines', label: 'Pipelines', icon: faProjectDiagram },
    { id: 'web-services', label: 'Web Services', icon: faGlobe },
    { id: 'external-sources', label: 'External Sources', icon: faSatellite },
    { id: 'debugging', label: 'Debugging Assistant', icon: faTools },
    { id: 'notifications', label: 'Notifications', icon: faEnvelope }
  ];

  const handleAIClick = () => {
    setAiAssistantClicked(true);
    onAIAssistantClick();
    setTimeout(() => setAiAssistantClicked(false), 200);
  };

  return (
    <div className="sidebar">
      <div className="sidebar-header">
        <Link to="/overview" style={{ textDecoration: 'none', color: 'inherit' }}>
          <h2 style={{ cursor: 'pointer' }}>
            <img src="/logo-spheroid.png" alt="SPHEROID" style={{ width: '4rem', height: '4rem', marginRight: '0.75rem', verticalAlign: 'middle' }} />
            <span style={{ marginLeft: '-0.5rem' }}>SPHEROID</span>
          </h2>
        </Link>
        <p>Earth Observation Monitoring</p>
        <div className="system-status">
          <div className="status-dot online"></div>
          <span className="status-text">System Online</span>
        </div>
      </div>

      <nav className="sidebar-nav">
        {menuItems.map(item => (
          item.isButton ? (
            <a
              key={item.id}
              href="#"
              className={`nav-item ${aiAssistantClicked ? 'active' : ''}`}
              onClick={(e) => {
                e.preventDefault();
                handleAIClick();
              }}
            >
              <FontAwesomeIcon icon={item.icon} className="nav-icon" fixedWidth />
              <span className="nav-label">{item.label}</span>
            </a>
          ) : (
            <Link
              key={item.id}
              to={`/${item.id}`}
              className={`nav-item ${activeTab === item.id ? 'active' : ''}`}
            >
              <FontAwesomeIcon icon={item.icon} className="nav-icon" fixedWidth />
              <span className="nav-label">{item.label}</span>
            </Link>
          )
        ))}
      </nav>

      <div className="sidebar-footer">
        <div className="system-status" style={{ width: '100%', justifyContent: 'center' }}>
          <div className="status-item" style={{ width: '100%', justifyContent: 'center' }}>
            <span className="status-value">v0.1.2</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;